import { Component, ElementRef, Input, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppRoutes } from 'src/app/app-routing.module';

@Component({
  selector: 'app-grid',
  templateUrl: './grid.component.html',
  styleUrls: ['./grid.component.scss'],
})
export class GridComponent {
  public active = false;
  public scrollDown = true;
  public scrollUp = false;
  public steps;
  public progress = 0;
  public amount = 200;
  public activeList;
  public itemsPerStep = 4;
  public items = [];
  public bagsRoute = AppRoutes.BAGS;

  @Input() set values(values) {
    this.items = values;
    this.steps = Math.ceil(this.items.length / this.itemsPerStep);

    if (this.steps > 1) {
      this.active = true;
    }

    this.assembleList();
  }

  @Input() public row: TemplateRef<any>;

  @ViewChild('holder', { static: true }) holder: ElementRef;
  @ViewChild('grid', { static: true }) grid: ElementRef;

  constructor(public Element: ElementRef, public router: Router) {
    if (this.router.url === this.bagsRoute) {
      this.itemsPerStep = 3;
    }
  }

  assembleList() {
    this.activeList = [];
    const init = this.progress * this.itemsPerStep;
    this.activeList = this.items.slice(init, init + this.itemsPerStep);
  }

  onScrollUp() {
    if (this.progress <= 0) {
      return false;
    }
    this.scrollDown = true;
    this.progress--;
    this.assembleList();
    if (this.progress <= 0) {
      this.scrollUp = false;
    }
  }

  onScrollDown() {
    if (this.progress >= this.steps - 1) {
      return false;
    }
    this.progress++;
    this.scrollUp = true;
    this.assembleList();
    if (this.progress === this.steps - 1) {
      this.scrollDown = false;
    }
  }
}
